import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import FilterLink from '../../../components/filter/FilterLink'
import MapPointPickerModal from './MapPointPickerModal'

const MapPointPicker = ({ value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <FilterLink
        icon={icon || 'RiAccountBoxLine'}
        label={label || 'Usuário'}
        value={compactString(value, { t: t, tField: 'userIds' })}
        onClick={() => setOpen(true)}
      />
      <MapPointPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default MapPointPicker
